import React, { useEffect, useRef, useState } from "react";
import "../scss/common.scss";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  BarController,
  LineController,
  Title,
  Tooltip,
  PointElement,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  BarController,
  LineController,
  Title,
  Tooltip,
  PointElement
);

/**
 * データの比較
 * @param {Object} obj1 - 比較するオブジェクト1
 * @param {Object} obj2 - 比較するオブジェクト2
 * @returns {boolean} - 完全一致の場合はtrue
 */
const deepEqual = (obj1, obj2) => {
  return JSON.stringify(obj1) === JSON.stringify(obj2);
};

const StudioData = ({
  monthPayment,
  revenues,
  salaries,
  trialsCount,
  loading = false,
}) => {
  const chartContainer = useRef(null);
  const chartInstance = useRef(null);
  const [prevData, setPrevData] = useState(null);

  const options = {
    plugins: {
      title: {
        display: true,
        text: "月別収支表",
      },
    },
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        stacked: true,
      },
      y: {
        stacked: true,
      },
      trialLinery: {
        type: "linear",
        min: 0,
        max: 50, // 折れ線グラフのY軸を50に固定
        position: "right",
      },
      allTrialLinery: {
        type: "linear",
        min: 0,
        max: 1000, // 折れ線グラフのY軸を1000に固定
        position: "right",
      },
    },
  };
  const labels = [
    "1月",
    "2月",
    "3月",
    "4月",
    "5月",
    "6月",
    "7月",
    "8月",
    "9月",
    "10月",
    "11月",
    "12月",
  ];

  const data = {
    labels,
    datasets: [
      {
        label: "利益",
        data: revenues
          ? revenues.map(
              (x, i) =>
                x.revenue -
                monthPayment[i].studio_cost -
                salaries[i].salary -
                monthPayment[i].trainfare -
                monthPayment[i].advertising_cost
            )
          : [],
        backgroundColor: "rgba(255, 99, 132, 0.5)",
      },
      {
        label: "スタジオ代",
        data: monthPayment.map((x) => x.studio_cost),
        backgroundColor: "rgba(53, 162, 235, 0.5)",
      },
      {
        label: "給料",
        data: salaries ? salaries.map((x) => x.salary) : [],
        backgroundColor: "rgba(75, 192, 192, 0.5)",
      },
      {
        label: "交通費",
        data: monthPayment.map((x) => x.trainfare),
        backgroundColor: "rgba(186, 128, 255, 0.5)",
      },
      {
        label: "広告費",
        data: monthPayment.map((x) => x.advertising_cost),
        backgroundColor: "rgba(255, 206, 86, 0.5)",
      },
      {
        type: "line",
        label: "所属者数",
        data: monthPayment.map((x) => x.members_count),
        borderColor: "rgba(247, 54, 137, 0.8)",
        yAxisID: "linery",
      },
    ],
  };

  useEffect(() => {
    // trialsCountにデータがあればdataにpush
    if (trialsCount && trialsCount.length > 0) {
      trialsCount.forEach((trial) => {
        data.datasets.push(trial);
      });
      // 全く同じデータの場合はグラフの再描画をスキップ
      if (!deepEqual(data, prevData)) {
        if (chartContainer && chartContainer.current) {
          // 既存のチャートが存在する場合は破棄
          if (chartInstance.current) {
            chartInstance.current.destroy();
          }

          // 新しいチャートを作成
          chartInstance.current = new ChartJS(chartContainer.current, {
            type: "bar",
            data: data,
            options: options,
          });

          // 現在のデータを保存
          setPrevData(data);
        }
      }
      console.log(data);
    }
  }, [data, prevData, trialsCount]);

  return (
    <div className="graphWrap" aria-busy={loading}>
      <canvas ref={chartContainer} style={{ height: "400px" }} />
      {loading && (
        <div className="graph-loading">
          <div className="spinner" role="status" aria-label="Loading" />
        </div>
      )}
    </div>
  );
};

export default StudioData;
